module.exports = __webpack_public_path__ + "static/media/NoImage.f3403121.png";